import { useSegmentAnalytics } from "./useSegmentAnalytics";

type MarketingButtonClickEvent = {
  label: string;
  campaign: string;
  assetType: string;
  assetLanguage: string;
  assetSize: string;
  assetName: string;
};

export const useMarketingPageAnalytics = () => {
  const { trackButtonClickEvent } = useSegmentAnalytics();

  const trackMarketingButtonClickEvent = ({
    label,
    campaign,
    assetType,
    assetLanguage,
    assetSize,
    assetName,
  }: MarketingButtonClickEvent) =>
    trackButtonClickEvent({
      label,
      location: "Marketing page",
      extraProperties: {
        filter_campaign: campaign,
        filter_type: assetType,
        filter_language: assetLanguage,
        filter_size: assetSize,
        element_name: assetName,
        event_type: "Click",
        link_text: label,
      },
    });

  return {
    trackMarketingButtonClickEvent,
  };
};
